import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from "@mui/material";
import { useState } from "react";

const UpgradeConfirmModal = ({ open, onClose, onConfirm, selectedPlan }) => {
  // const [couponCode, setCouponCode] = useState('');

  // const handleConfirm = () => {
  //   onConfirm(couponCode);
  // };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        elevation: 24,
      }}
    >
      <DialogTitle sx={{ fontSize: 24, fontWeight: 600, pt: 3 }}>
        Confirm {selectedPlan?.name ? `Upgrade to ${selectedPlan.name}` : "Upgrade"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ fontSize: 16, color: 'text.primary' }}>
          Are you sure you want to change your plan?
        </DialogContentText>

        {/* <TextField
          margin="dense"
          id="coupon"
          label="Coupon Code (optional)"
          type="text"
          fullWidth
          variant="outlined"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          sx={{
            my: 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        /> */}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          color="primary"
          sx={{ minWidth: 100 }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeConfirmModal;
